import { AMM_STAGING_PREVIEW, ENV_PRODUCTION, ENV_TESTNET } from './env';

export const API_LIMIT = 200;

export const API_URL_STELLAR_EXPERT = 'https://api.stellar.expert/';
export const API_CMC = 'https://cmc.aqua.network/api';
export const API_ASSETS_LIST_URL = 'https://fed.stellarterm.com/issuer_orgs/';
export const API_ASSETS_INFO = 'https://assets.aqua.network/api/v1/assets/';

export const LOBSTR_VAULT_API_URL = 'https://vault.lobstr.co/api/transactions/';

export const API_ST_TICKER = 'https://api.stellarterm.com/v1/ticker.json';

export const API_AIRDROP_2 = 'https://airdrop2-checker-api.aqua.network/api/snapshot/';

export const API_URLS = {
    [ENV_PRODUCTION]: {
        onRampProxy: 'https://soroban-on-ramp.coindisco.com',
        horizon: 'https://horizon.stellar.org',
        // soroban: 'https://mainnet.sorobanrpc.com/',
        soroban: 'https://soroban-rpc.aqua.network/',
        ammAqua: AMM_STAGING_PREVIEW
            ? 'https://amm-api-staging.aqua.network'
            : 'https://amm-api.aqua.network',
        governance: 'https://governance-api.aqua.network/api',
        rewards: 'https://reward-api.aqua.network/api/rewards/',
        bribes: 'https://bribes-api.aqua.network/api/',
        marketKeys: 'https://marketkeys-tracker.aqua.network/api/market-keys/',
        votingTracker: 'https://voting-tracker.aqua.network/api/voting-snapshot/',
        delegation: 'https://api-delegation.aqua.network/api/delegation/',
        iceApproval: 'https://ice-approval.aqua.network/api',
        iceLocker: 'https://ice-distributor.aqua.network/api',
        notifications: 'https://notifications.aqua.network',
    },
    [ENV_TESTNET]: {
        onRampProxy: 'https://soroban-on-ramp-testnet.aqua.network',
        horizon: 'https://horizon-testnet.stellar.org',
        soroban: 'https://soroban-testnet.stellar.org:443/',
        ammAqua: 'https://amm-api-testnet.aqua.network',
        governance: 'https://governance-api-testnet.aqua.network/api',
        rewards: 'https://reward-api-testnet.aqua.network/api/rewards/',
        bribes: 'https://bribes-api-testnet.aqua.network/api/',
        marketKeys: 'https://marketkeys-tracker-testnet.aqua.network/api/market-keys/',
        votingTracker: 'https://voting-tracker-testnet.aqua.network/api/voting-snapshot/',
        delegation: 'https://api-delegation-testnet.aqua.network/api/delegation/',
        iceApproval: 'https://ice-approval-testnet.aqua.network/api',
        iceLocker: 'https://ice-distributor-testnet.aqua.network/api',
        notifications: 'https://notifications-testnet.aqua.network',
    },
};

// Bot-issued link codes must be confirmed against the API for the same network.
export const NOTIFICATIONS_BOT_URLS = {
    [ENV_PRODUCTION]: {
        telegram: 'https://t.me/AquariusNotifyBot',
        discord:
            'https://discord.com/oauth2/authorize?client_id=976743821415157801&integration_type=1&scope=applications.commands',
        discordDm: 'https://discord.com/users/976743821415157801',
    },
    [ENV_TESTNET]: {
        telegram: 'https://t.me/AquariusTestNotificationsBot',
        discord:
            'https://discord.com/oauth2/authorize?client_id=1531981226926276618&integration_type=1&scope=applications.commands',
        discordDm: 'https://discord.com/users/1531981226926276618',
    },
} as const;
